import React from 'react'
import PropTypes from 'prop-types'
import {Box, Flex, Img, Text, useMultiStyleConfig, useStyleConfig} from '@chakra-ui/react'
import {Link as RouterLink} from 'react-router-dom'
import {getDamImagePicture} from '../../../../custom-hooks/use-dam-image'

const CategoryCard = ({title, subtitle, image, url, isAbsolute, icon}) => {
    const styles = useStyleConfig('CarouselCards')
    const keyFeatureStyles = useMultiStyleConfig('KeyFeatures')

    const linkProps = url
        ? isAbsolute
            ? {as: 'a', href: url, target: '_blank', rel: 'noopener noreferrer'}
            : {as: RouterLink, to: url}
        : {}

    return (
        <Flex
            {...styles?.card}
            {...styles?.categoryCard}
            {...(url ? styles?.cardInteractive : {})}
            {...linkProps}
            data-testid="carousel-cards-category-card"
            data-card-variant="category"
        >
            {icon?.url && (
                <Flex {...keyFeatureStyles.cardIconAlignment} {...styles?.categoryIconAlignment}>
                    <Box
                        pointerEvents="none"
                        {...keyFeatureStyles.cardIconContainer}
                        {...styles?.categoryIconContainer}
                        aria-hidden="true"
                    >
                        <Img
                            src={icon?.url}
                            alt=""
                            {...styles?.categoryIcon}
                            aria-hidden="true"
                            data-testid="carousel-cards-category-icon"
                        />
                    </Box>
                </Flex>
            )}
            {image && (
                <Box {...styles?.categoryMedia}>
                    <Box
                        {...styles?.categorySharpMedia}
                        data-testid="carousel-cards-category-sharp-image"
                    >
                        {getDamImagePicture(image, title || '', false, 448 / 598, {
                            objectFit: 'cover',
                            mixBlendMode: 'multiply',
                        })}
                    </Box>
                    <Box
                        {...styles?.categoryBlurClip}
                        aria-hidden="true"
                        data-testid="carousel-cards-category-blur-clip"
                    >
                        <Box
                            {...styles?.categoryBlurMedia}
                            data-testid="carousel-cards-category-blur-image"
                        >
                            {getDamImagePicture(image, '', false, 448 / 598, {
                                objectFit: 'cover',
                                mixBlendMode: 'multiply',
                            })}
                        </Box>
                    </Box>
                </Box>
            )}
            <Flex {...styles?.categoryBody}>
                {title && (
                    <Text as="h3" {...styles?.categoryTitle}>
                        {title}
                    </Text>
                )}
                {subtitle && <Text {...styles?.categorySub}>{subtitle}</Text>}
            </Flex>
        </Flex>
    )
}

CategoryCard.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    image: PropTypes.object,
    url: PropTypes.string,
    isAbsolute: PropTypes.bool,
    icon: PropTypes.shape({url: PropTypes.string}),
}

export default CategoryCard
